import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Row, Col, ListGroup, Image, Card } from 'react-bootstrap';
import Message from '../components/Message';
import Loader from '../components/Loader';
import { useGetDailyStockDetailsQuery } from '../slices/dailyStocksApiSlice';

const DailyStockScreen = () => {
  const { id: dailyStockId } = useParams();

  const { data: dailyStock, refetch, isLoading, error } = useGetDailyStockDetailsQuery(dailyStockId);

  useEffect(() => {
    if (!dailyStock) {
      refetch();
    }
  }, [dailyStock, refetch]);

  return isLoading ? (
    <Loader />
  ) : error ? (
    <Message variant="danger">{error?.data?.message || error.error}</Message>
  ) : (
    <>
      <h1>DailyStock {dailyStock?._id || 'N/A'}</h1>
      <Row>
        <Col md={8}>
          <ListGroup variant="flush">
            <ListGroup.Item>
              <h2>Customer Details</h2>
              <p>
                <strong>Name: </strong> {dailyStock?.customerDetails?.name || 'N/A'}
              </p>
              <p>
                <strong>Company: </strong> {dailyStock?.customerDetails?.company || 'N/A'}
              </p>
              <p>
                <strong>Phone: </strong> {dailyStock?.customerDetails?.telephone || 'N/A'}
              </p>
              <p>
                <strong>Address: </strong> {dailyStock?.customerDetails?.address || 'N/A'}
              </p>
              <p>
                <strong>Serial: </strong> {dailyStock?.customerDetails?.serialNumber || 'N/A'}
              </p>
            </ListGroup.Item>

            <ListGroup.Item>
              <h2>DailyStock Note</h2>
              <p>{dailyStock?.note || 'No additional notes provided'}</p>
            </ListGroup.Item>

            <ListGroup.Item>
              <h2>DailyStock Items</h2>
              {dailyStock?.dailyStockItems?.length === 0 ? (
                <Message>This dailyStock has no items</Message>
              ) : (
                <ListGroup variant="flush">
                  {dailyStock?.dailyStockItems?.map((item, index) => (
                    <ListGroup.Item key={index}>
                      <Row>
                        <Col md={1}>
                          <Image
                            src={item?.images?.[0] || 'https://via.placeholder.com/40'}
                            alt={item?.name || 'Unnamed'}
                            fluid
                            rounded
                          />
                        </Col>
                        <Col>
                          <strong>{item?.name || 'Unnamed'}</strong>
                        </Col>
                        <Col md={4}>
                          {item?.qty || 0} x ${item?.price || 0} = D
                          {(item?.qty || 0) * (item?.price || 0)}
                        </Col>
                      </Row>
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              )}
            </ListGroup.Item>
          </ListGroup>
        </Col>
        <Col md={4}>
          <Card>
            <ListGroup variant="flush">
              <ListGroup.Item>
                <h2>DailyStock Summary</h2>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>Date</Col>
                  <Col>{dailyStock?.date?.substring(0, 10) || 'N/A'}</Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>Total</Col>
                  <Col>D{dailyStock?.totalPrice || 0}</Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>Status</Col>
                  <Col>{dailyStock?.status || 'N/A'}</Col>
                  <Col>{dailyStock?.username || 'No user name provided'}</Col>
                </Row>
              </ListGroup.Item>
            </ListGroup>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default DailyStockScreen;